import React from 'react';
import {
  defineMessages,
  FormattedMessage,
  type MessageValue,
  type NoMessageValues,
} from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

import { BodyText, Icon } from '@sg/garnish';

export const LoyaltyPointsExpirationRow = (props: LoyaltyPointsExpirationRowProps) => {
  const { amountExpiring, numOfDaysUntilExpiration } = props;

  return (
    <View style={styles.container}>
      <View style={styles.textContentWrapper}>
        <BodyText sizeMatch={['18']}>
          <FormattedMessage {...messages.expiration} values={{ days: numOfDaysUntilExpiration }} />
        </BodyText>

        <BodyText sizeMatch={['14']} style={styles.charcoalText}>
          <FormattedMessage {...messages.hint} />
        </BodyText>
      </View>

      <View style={styles.amountWrapper}>
        <BodyText sizeMatch={['24']}>{amountExpiring}</BodyText>

        <Icon width={16} height={16} name="IconSgRewardBlackFill" />
      </View>
    </View>
  );
};

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages<{
  readonly expiration: { readonly days: MessageValue };
  readonly hint: NoMessageValues;
}>({
  expiration: {
    defaultMessage: 'Expiring within {days} days',
    description: 'Loyalty | Points Expiration | Expiration',
  },
  hint: {
    defaultMessage: 'Points expire 180 days after deposit',
    description: 'Loyalty | Points Expiration | Hint',
  },
});

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: theme.spacing['6'],
    gap: theme.spacing['4'],
  },
  textContentWrapper: {
    flex: 1,
  },
  amountWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['1'],
  },
  charcoalText: {
    color: theme.colors.CHARCOAL,
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type LoyaltyPointsExpirationRowProps = {
  amountExpiring: number;
  numOfDaysUntilExpiration: number;
};
